import { MediaSelect } from "@/(admin)/modules/media/pages/SelectMediaUIBuilder"
import { ComponentConfig } from "@measured/puck"
import { commonStylesProps } from "../../../lib/commonCSSProps"
import { CarouselProp, RenderConfig } from "./RenderConfig"

export const CaoCaoCarousel: ComponentConfig<CarouselProp> = {
  label: "CaoCao | Carousel",
  //@ts-ignore
  fields: {
    items: {
      label: "Items",
      type: "array",
      arrayFields: {
        imageUrl: {
          label: "Image URL",
          type: "custom",
          render: props => <MediaSelect {...props} />,
        },
        title: {
          label: "Title",
          type: "text",
        },
        description: {
          label: "Description",
          type: "text",
        },
        buttonText: {
          label: "Button Text",
          type: "text",
        },
        buttonUrl: {
          label: "Button URL",
          type: "text",
        },
      },
    },
    titleStyle: {
      label: "Title Style",
      type: "object",
      objectFields: {
        desktop: {
          label: "Desktop",
          type: "object",
          objectFields: {
            fontSize: {
              label: "Font Size",
              type: "text",
            },
            fontWeight: {
              label: "Font Weight",
              type: "text",
            },
            lineHeight: {
              label: "Line Height",
              type: "text",
            },
            color: {
              label: "Text Color",
              type: "text",
            },
          },
        },
        mobile: {
          label: "Mobile",
          type: "object",
          objectFields: {
            fontSize: {
              label: "Font Size",
              type: "text",
            },
            fontWeight: {
              label: "Font Weight",
              type: "text",
            },
            lineHeight: {
              label: "Line Height",
              type: "text",
            },
            color: {
              label: "Text Color",
              type: "text",
            },
          },
        },
      },
    },
    descriptionStyle: {
      label: "Description Style",
      type: "object",
      objectFields: {
        desktop: {
          label: "Desktop",
          type: "object",
          objectFields: {
            fontSize: {
              label: "Font Size",
              type: "text",
            },
            fontWeight: {
              label: "Font Weight",
              type: "text",
            },
            lineHeight: {
              label: "Line Height",
              type: "text",
            },
            color: {
              label: "Text Color",
              type: "text",
            },
          },
        },
        mobile: {
          label: "Mobile",
          type: "object",
          objectFields: {
            fontSize: {
              label: "Font Size",
              type: "text",
            },
            fontWeight: {
              label: "Font Weight",
              type: "text",
            },
            lineHeight: {
              label: "Line Height",
              type: "text",
            },
            color: {
              label: "Text Color",
              type: "text",
            },
          },
        },
      },
    },

    ...commonStylesProps,
  },
  defaultProps: {
    items: [
      {
        imageUrl: "",
        title: "Sai Gon & Mekong",
        buttonText: "See tours",
        buttonUrl: "/en/saigon-mekong",
      },
      {
        imageUrl: "",
        title: "Sai Gon & Mekong",
        buttonText: "See tours",
        buttonUrl: "/en/saigon-mekong",
      },
      {
        imageUrl: "",
        title: "Sai Gon & Mekong",
        buttonText: "See tours",
        buttonUrl: "/en/saigon-mekong",
      },
    ],
    className: "",
    titleStyle: {
      desktop: {
        fontSize: "",
        fontWeight: "",
        lineHeight: "",
        color: "",
      },
      mobile: {
        fontSize: "",
        fontWeight: "",
        lineHeight: "",
        color: "",
      },
    },
    descriptionStyle: {
      desktop: {
        fontSize: "",
        fontWeight: "",
        lineHeight: "",
        color: "",
      },
      mobile: {
        fontSize: "",
        fontWeight: "",
        lineHeight: "",
        color: "",
      },
    },
  },

  ...RenderConfig,
}

export default CaoCaoCarousel
